<template>
  <div class="image-class">
    <div class="image-content">
      <img :src="fileUrl" style="max-height: 600px; width: 100%" alt="" />
    </div>
    <LabelSelect ref="LabelSelectRef" @change="labelChange" />
  </div>
</template>

<script setup>
import { defineExpose, getCurrentInstance, ref, defineEmits } from "vue";
import LabelSelect from "./LabelSelect.vue";
const { proxy } = getCurrentInstance();
const emit = defineEmits(["change"]);
const fileUrl = ref("");
const labelValue = ref(null);
const labelChange = (val) => {
  labelValue.value = val;
  emit("change", [{ cls: val.id }]);
};
const open = async (question, answer) => {
  fileUrl.value = question.url;
  labelValue.value = null;
  const labels = JSON.parse(question.problem);
  proxy.$refs.LabelSelectRef.setOptions(labels);

  if (answer && answer.length > 0) {
    const res = labels.find((i) => i.id === answer[0].cls);
    proxy.$refs.LabelSelectRef.changeLabel(res);
  }
};
defineExpose({ open });
</script>

<style scoped lang="less">
.image-class {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  .image-content {
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: center;
  }
}
</style>
